import o from"./actions.js";import r from"./products.js";import{PRIMARIES as t}from"./primary.js";import m from"./adaptor.js";const p={...m,...o,...r,...t};export{p as default};
//# sourceMappingURL=index.js.map
